export default __webpack_public_path__ + "static/media/info.b6c887b0.svg";